import React from 'react'

function CommunitySpace() {
  return (
    <div className='display-5 text-center mt-5 fw-bold'>
      Coming soon...
    </div>
  )
}

export default CommunitySpace
